import { motion } from "framer-motion";
import { Play, ArrowUpRight } from "lucide-react";
import { WORKS, PROFILE } from "@/data/content";
import { Reveal } from "@/components/bits/Reveal";
import { Sticker, Tape, HandNote } from "@/components/bits/Sticker";
import { Thumb } from "@/components/bits/Slate";

export const Works = ({ onOpen }) => (
  <section className="relative max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-28" data-testid="works-section">
    <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-14">
      <div>
        <HandNote className="text-2xl block -rotate-1">and the rest of the reel</HandNote>
        <h2 className="pixel-title text-4xl sm:text-5xl md:text-6xl mt-1">Commercials & films</h2>
      </div>
      <a href={PROFILE.socials[0].href} target="_blank" rel="noreferrer" data-testid="vimeo-link" className="self-start sm:self-auto">
        <Sticker color="ink" rotate={2} icon={<ArrowUpRight size={12} />}>All 21 on Vimeo</Sticker>
      </a>
    </Reveal>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
      {WORKS.map((w, i) => (
        <motion.button
          key={w.id}
          data-testid={`work-card-${i}`}
          onClick={() => onOpen(w)}
          className="group text-left"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-5% 0px" }}
          transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="polaroid wide" style={{ "--r": `${[-2, 1.5, -1, 2, -1.5, 1][i % 6]}deg` }}>
            <Tape rotate={[-6, 5, -4][i % 3]} className="-top-3 left-1/2 -translate-x-1/2" color={["", "blue", "pink", "green"][i % 4]} />
            <div className="relative overflow-hidden bg-black">
              <Thumb item={w} className="group-hover:scale-[1.04] transition-transform duration-700" />
              <span className={`absolute ${w.slate ? "right-3 bottom-6" : "inset-0"} flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity`}>
                <span className="w-12 h-12 rounded-full bg-[var(--yellow)] border-[1.5px] border-[var(--ink)] flex items-center justify-center hard-shadow">
                  <Play size={16} fill="currentColor" />
                </span>
              </span>
              <span className="absolute top-2 left-2 font-mono text-[0.6rem] tracking-[0.15em] uppercase bg-white px-2 py-1 border border-[var(--ink)] flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[var(--ink)]" /> {w.duration && `${w.duration} · `}{w.brand}
              </span>
            </div>
            <div className="absolute left-3 right-3 bottom-3 flex items-end justify-between gap-3">
              <div className="min-w-0">
                <div className="font-body font-semibold text-[0.95rem] leading-tight truncate">{w.title}</div>
                {w.sub && <div className="font-hand text-lg text-[var(--ink-60)] leading-none mt-1 truncate">{w.sub}</div>}
              </div>
              <Sticker color={w.color} rotate={-3} className="!text-[0.55rem] !px-2 !py-1 shrink-0">{w.role}</Sticker>
            </div>
          </div>
        </motion.button>
      ))}
    </div>
  </section>
);
